import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";

/**
 * Renders an input field with a label inside a Grid item.
 *
 * @param {string} name - The name attribute for the input field.
 * @param {string} label - The label text to display above the input field.
 * @param {string} [type="text"] - The type attribute for the input field (e.g., "text", "password").
 * @param {string} placeholder - The placeholder text for the input field.
 * @param {number} [xl=3] - The number of columns the Grid item should span on extra-large screens.
 * @param {Object} information - An object containing the current values of the input fields.
 * @param {function} handleChange - The function to call when the input field value changes.
 * @returns {JSX.Element} The rendered input field component.
 */
const renderInputField = (name, label, type = "text", placeholder, information, handleChange, xl = 3) => (
    <Grid item xs={12} sm={6} xl={xl}>
        <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
                {label}
            </SoftTypography>
        </SoftBox>
        <SoftInput
            name={name}
            value={information[name]}
            onChange={handleChange}
            type={type}
            placeholder={placeholder}
        />
    </Grid>
);
export default renderInputField